import React from "react";
import { cn } from "../../lib/utils.js";
import type { DataTableColumn } from "./DataTable.js";
import { foldClass } from "./data-table-columns.js";

/* ---------------- DataTableFolds ----------------
   The values of `hideBelow` columns folded into another column's cell
   (`foldInto`), rendered under that cell's own content. Each copy shows only
   while its column is hidden and is display:none once the column shows, so a
   reader never meets the value twice. The column's header leads each copy as
   sr-only text, because a value moved out of its column has lost the header
   that named it. */

export interface DataTableFoldsProps<Row> {
  readonly columns: ReadonlyArray<DataTableColumn<Row>>;
  readonly row: Row;
}

export function DataTableFolds<Row>({
  columns,
  row,
}: DataTableFoldsProps<Row>): React.ReactElement {
  return (
    <>
      {columns.map((col) =>
        col.hideBelow ? (
          <div
            key={col.id}
            data-fold={col.id}
            className={cn(
              "mt-1 text-pb-text-secondary",
              foldClass(col.hideBelow),
            )}
          >
            <span className="sr-only">{col.header}: </span>
            {col.cell(row)}
          </div>
        ) : null,
      )}
    </>
  );
}
